(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('cart:updated', function(event) {
      console.log(event, 'event');
      const updatedCart = event.detail.cart;
      console.log(updatedCart, 'updatedCart');
    });
  });
  
  (() => {
    const selector = '#checkout'
    
    const checkoutHandler = async (event) => {
      if (!window.skio_ran_tier_discount && event.target.matches(selector)) {
        event.preventDefault()
    
        // Get Skio rules and the current cart
        const [{rules}, cart] = await Promise.all([
          (await fetch(`https://api.skio.com/storefront-http/get-rules-by-domain-or-hostname?domain=${window?.Shopify?.shop}`)).json(), 
          (await fetch('/cart.js')).json()
        ])
      
        console.log('rules', rules)
        console.log('cart', cart)
      
        // Check each rule to find the eligible rule 
        // with the largest min quantity
        let largestMinQuantity = {
          value: -1,
          index: -1,
        }
        rules.forEach((rule, index) => {
          if (rule.code &&
              largestMinQuantity.value < rule.minQuantityToDiscount
          ) {
            // Gets the count of eligible items in the cart for this rule
            const eligibleCount = cart.items.reduce(
              (aggregate, item) => rule.productVariantIds.some(gid => gid.includes(item.id)) ? 
                  aggregate + item.quantity : aggregate 
              , 0)
            if (rule.minQuantityToDiscount <= eligibleCount) {
              largestMinQuantity.value = rule.minQuantityToDiscount
              largestMinQuantity.index = index
            }
          }
        })
      
        const rule = largestMinQuantity.index > -1 ? rules[largestMinQuantity.index] : null
        // console.log(rule)
        
        // Apply code
        if (rule) await fetch(`/discount/${rule.code}`)
        
        window.skio_ran_tier_discount = true
        
        event.target.click()
      }
    }
    
    // Event delegation
    document.body.addEventListener('click', checkoutHandler)
  })()

  // Free Samples Scroll Navigation is handled in cart-drawer.js

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-biological-age-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  var FIELDS = [
    { id: "sleep", label: "How many hours do you usually sleep?", name: "Sleep",
      opts: [["Under 5", 2.0], ["5 to 6", 1.0], ["6 to 7", 0.3], ["7 to 9", -0.8], ["Over 9", 0.5]],
      tip: "Aim for a consistent seven to nine hours. A fixed wake time is the easiest lever to start with." },
    { id: "cardio", label: "Days per week you raise your heart rate for 20+ minutes", name: "Cardio",
      opts: [["0", 1.2], ["1 to 2", 0.2], ["3 to 4", -0.8], ["5 or more", -1.2]],
      tip: "Build toward about 150 minutes a week of moderate activity. Two brisk 20-minute walks add up quickly." },
    { id: "strength", label: "Strength training sessions per week", name: "Strength training",
      opts: [["None", 0.8], ["1", 0], ["2 to 3", -0.8], ["4 or more", -1.0]],
      tip: "Add two short strength sessions a week. Muscle mass supports metabolism and independence as you age." },
    { id: "steps", label: "Typical daily steps", name: "Daily steps",
      opts: [["Under 3,000", 1.5], ["3,000 to 6,000", 0.5], ["6,000 to 9,000", -0.3], ["9,000+", -0.8]],
      tip: "Add 1,000 steps at a time. A ten-minute walk after meals is an easy habit to anchor." },
    { id: "diet", label: "How would you describe your eating?", name: "Eating pattern",
      opts: [["Mostly whole foods", -1.2], ["A mix", 0], ["Mostly processed", 1.5]],
      tip: "Shift one meal a day toward whole foods: vegetables, protein, fiber, and healthy fats." },
    { id: "alcohol", label: "Alcoholic drinks per week", name: "Alcohol",
      opts: [["0 to 2", -0.3], ["3 to 7", 0.2], ["8 to 14", 1.0], ["15 or more", 2.2]],
      tip: "Try cutting back to a few drinks a week and notice how your sleep and energy respond." },
    { id: "smoking", label: "Do you smoke or vape nicotine?", name: "Nicotine",
      opts: [["Never", -0.3], ["Used to", 0.4], ["Currently", 4.0]],
      tip: "Quitting is the biggest single change on this list. A healthcare provider can help you build a plan that fits." },
    { id: "stress", label: "How would you rate your daily stress?", name: "Stress",
      opts: [["Low", -0.6], ["Moderate", 0.3], ["High", 1.3], ["Constant", 2.0]],
      tip: "Protect a daily wind-down window. Ten minutes of breathwork or a phone-free walk counts." },
    { id: "sun", label: "How often do you protect your skin from the sun?", name: "Sun protection",
      opts: [["Almost always", -0.5], ["Sometimes", 0], ["Rarely", 0.8]],
      tip: "Make daily SPF part of your morning routine and seek shade during peak hours." }
  ];

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function calculate(age, picks) {
    var sum = 0;
    var rows = FIELDS.map(function (f, i) {
      var o = f.opts[picks[i]];
      sum += o[1];
      return { f: f, answer: o[0], offset: o[1] };
    });
    var mult = Math.min(1.25, Math.max(0.5, age / 45));
    var total = Math.max(-10, Math.min(10, sum * mult));
    var bio = Math.max(18, Math.round(age + total));
    return { bio: bio, diff: bio - age, rows: rows };
  }

  function init(root) {
    if (!root || root.getAttribute("data-bac-ready") === "true") return;
    root.setAttribute("data-bac-ready", "true");

    var form = root.querySelector("[data-bac-form]");
    var fieldsEl = root.querySelector("[data-bac-fields]");
    var errEl = root.querySelector("[data-bac-error]");
    var resultsEl = root.querySelector("[data-bac-results]");
    var ageEl = root.querySelector("[data-bac-age]");
    var uid = root.id;
    if (!form || !fieldsEl || !resultsEl || !ageEl) return;

    FIELDS.forEach(function (f) {
      var fs = document.createElement("fieldset");
      var lg = document.createElement("legend");
      lg.textContent = f.label;
      fs.appendChild(lg);
      var wrap = document.createElement("div");
      wrap.className = "sw-bac__pills";
      f.opts.forEach(function (o, i) {
        var l = document.createElement("label");
        l.className = "sw-bac__pill";
        var inp = document.createElement("input");
        inp.type = "radio";
        inp.name = uid + "-" + f.id;
        inp.value = String(i);
        var sp = document.createElement("span");
        sp.textContent = o[0];
        l.appendChild(inp);
        l.appendChild(sp);
        wrap.appendChild(l);
      });
      fs.appendChild(wrap);
      fieldsEl.appendChild(fs);
    });

    function render(age, res) {
      var d = root.dataset;
      var diff = res.diff;
      var older = diff > 0;
      var headline;
      if (diff <= -1) {
        headline = "Your habits point to a biological age about " + Math.abs(diff) + (Math.abs(diff) === 1 ? " year" : " years") + " younger than your calendar age.";
      } else if (diff >= 1) {
        headline = "Your habits point to a biological age about " + diff + (diff === 1 ? " year" : " years") + " above your calendar age. That’s a starting point, not a verdict.";
      } else {
        headline = "Your habits put you right in step with your calendar age.";
      }

      var bioPos = 50 + (diff / 12) * 50;
      bioPos = Math.max(8, Math.min(92, bioPos));
      var calPos = 50;
      if (Math.abs(bioPos - calPos) < 14) { bioPos = calPos + (diff >= 0 ? 14 : -14); }

      var rowsHtml = res.rows.map(function (r) {
        var cls = r.offset <= -0.4 ? "is-good" : (r.offset >= 0.4 ? "is-improve" : "");
        var tag = r.offset <= -0.4 ? "Working for you" : (r.offset >= 0.4 ? "Room to improve" : "Neutral");
        return '<li class="sw-bac__factor ' + cls + '"><div><div class="name">' + esc(r.f.name) + '</div><div class="ans">' + esc(r.answer) + '</div></div><div class="tag">' + tag + '</div></li>';
      }).join("");

      var worst = res.rows.filter(function (r) { return r.offset >= 0.4; })
        .sort(function (a, b) { return b.offset - a.offset; })
        .slice(0, 3);
      var stepsHtml;
      if (worst.length) {
        stepsHtml = '<h3 class="sw-bac__h3">Your top ' + (worst.length === 1 ? "priority" : worst.length + " priorities") + '</h3><ol class="sw-bac__steps">' +
          worst.map(function (r) { return "<li><strong>" + esc(r.f.name) + ":</strong> " + esc(r.f.tip) + "</li>"; }).join("") + "</ol>";
      } else {
        stepsHtml = '<h3 class="sw-bac__h3">Keep it going</h3><p>None of your nine habits are flagged for improvement. The next step is consistency: recalculate in two to three months and keep your routine steady.</p>';
      }

      var ctaHtml = "";
      if (d.cta1Url || d.cta2Url) {
        ctaHtml = '<div class="sw-bac__cta">' +
          (d.ctaHeading ? '<h3 class="sw-bac__h3">' + esc(d.ctaHeading) + '</h3>' : "") +
          (d.ctaText ? '<p>' + esc(d.ctaText) + '</p>' : "") +
          '<div class="row">' +
            (d.cta1Url ? '<a class="sw-bac__btn" href="' + esc(d.cta1Url) + '">' + esc(d.cta1Label || "Shop now") + '</a>' : "") +
            (d.cta2Url ? '<a class="sw-bac__btn sw-bac__btn--outline" href="' + esc(d.cta2Url) + '">' + esc(d.cta2Label || "Shop now") + '</a>' : "") +
          '</div></div>';
      }

      resultsEl.innerHTML =
        '<div class="sw-bac__card">' +
          '<h2 class="sw-bac__h2" id="' + uid + '-result-title" tabindex="-1">Your estimated <em>biological age</em></h2>' +
          '<p class="sw-bac__big">' + res.bio + '<small>years (calendar age ' + age + ')</small></p>' +
          '<p>' + esc(headline) + '</p>' +
          '<div class="sw-bac__ruler" role="img" aria-label="Calendar age ' + age + ', estimated biological age ' + res.bio + '">' +
            '<div class="sw-bac__track"></div>' +
            '<div class="sw-bac__dot sw-bac__dot--cal" style="left:' + calPos + '%"></div>' +
            '<div class="sw-bac__dot sw-bac__dot--bio' + (older ? " is-older" : "") + '" style="left:' + bioPos + '%"></div>' +
            '<div class="sw-bac__marker sw-bac__marker--cal" style="left:' + calPos + '%"><b>' + age + '</b>Calendar age<i></i></div>' +
            '<div class="sw-bac__marker sw-bac__marker--bio' + (older ? " is-older" : "") + '" style="left:' + bioPos + '%"><i></i><b>' + res.bio + '</b>Habit-based estimate</div>' +
          '</div>' +
          '<h3 class="sw-bac__h3">How each habit is doing</h3>' +
          '<ul class="sw-bac__factors">' + rowsHtml + '</ul>' +
          stepsHtml + ctaHtml +
          '<p class="sw-bac__fine" style="margin-top:2rem">This estimate is based on lifestyle habits and is for educational purposes only. It is not a medical diagnosis or a lab measurement of biological age. *These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.</p>' +
        '</div>';
      resultsEl.hidden = false;

      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var t = document.getElementById(uid + "-result-title");
      resultsEl.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
      if (t) { t.focus({ preventScroll: true }); }

      // Analytics: no personal data, only the direction and size of the gap
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "bio_age_calculated", bio_age_delta: diff });
      } catch (e) {}
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      errEl.textContent = "";
      var age = parseInt(ageEl.value, 10);
      if (!age || age < 18 || age > 90) {
        errEl.textContent = "Enter an age between 18 and 90.";
        ageEl.focus();
        return;
      }
      var picks = [];
      for (var i = 0; i < FIELDS.length; i++) {
        var checked = form.querySelector('input[name="' + uid + "-" + FIELDS[i].id + '"]:checked');
        if (!checked) {
          errEl.textContent = "Please answer: " + FIELDS[i].label;
          var first = form.querySelector('input[name="' + uid + "-" + FIELDS[i].id + '"]');
          if (first) { first.focus(); }
          return;
        }
        picks.push(parseInt(checked.value, 10));
      }
      render(age, calculate(age, picks));
    });

    form.addEventListener("reset", function () {
      errEl.textContent = "";
      resultsEl.hidden = true;
      resultsEl.innerHTML = "";
    });
  }

  function initAll() {
    document.querySelectorAll("[data-sw-bac]").forEach(init);
  }

  initAll();
  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-what-is-inside"] && !Shopify.designMode) return;
  try {
    
(function () {
  function update(grid) {
    if (grid.scrollWidth > grid.clientWidth + 1) {
      grid.setAttribute('tabindex', '0');
    } else {
      grid.removeAttribute('tabindex');
    }
  }
  function updateAll() {
    document.querySelectorAll('.sw-wii__grid').forEach(update);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
  window.addEventListener('resize', updateAll);
  document.addEventListener('shopify:section:load', updateAll);
})();

  } catch(e) { console.error(e); }
})();
})();
